import React from "react";
import "./hero.css";
import Header from "../header/header";
import hero_image from "../../assets/hero_image.png";
import hero_image_back from "../../assets/hero_image_back.png";
import heart from "../../assets/heart.png";
import calories from "../../assets/calories.png";
import { motion } from "framer-motion";
import NumberCounter from "number-counter";
const hero = () => {
  const transition = { type: "spring", duration: 3 };
  const mobile = window.innerWidth <= 768 ? true : false;
  return (
    <div className="hero" id="home">
      <div className="blur hero-blur"></div>
      <div className="hero-l">
        <Header></Header>
        {/* the best ad  */}
        <div className="the-best-ad">
          <motion.div
            initial={{ left: mobile ? "162px" : "238px" }}
            whileInView={{ left: "8px" }}
            transition={{ ...transition, type: "tween" }}
          ></motion.div>
          <span>The best fitness club in the town</span>
        </div>
        {/* hero text section  */}
        <div className="hero-text">
          <div>
            <span className="stroke-text">shape </span>
            <span>your</span>
          </div>
          <div>
            <span>ideal body</span>
          </div>
          <div>
            <span>
              In here we will help you to shape and build your ideal body and
              live up your life to fullest
            </span>
          </div>
        </div>
        {/* figures */}
        <div className="figures">
          <div>
            <span style={{display:"flex"}}>+ 
              <NumberCounter end={140} start={100}   delay="4"  />
            </span>
            <span>expert coaches</span>
          </div>
          <div>
          <span style={{display:"flex"}}>+ 
              <NumberCounter end={978} start={920}   delay="5"  />
            </span>
            <span>members joined</span>
          </div>
          <div>
          <span style={{display:"flex"}}>+ 
              <NumberCounter end={50} start={20}   delay="3"  />
            </span>
            <span>fitness programmes</span>
          </div>
        </div>
        <div className="hero-buttons">
          <buttons className="btn">Get Started</buttons>
          <buttons className="btn">Learn More</buttons>
        </div>
      </div>
      {/* right side  */}
      <div className="hero-r">
        <button className="btn">Join Now</button>
        <motion.div
          transition={transition}
          initial={{ right: "-1rem" }}
          whileInView={{ right: "4rem" }}
          className="heart-rate"
        >
          <img src={heart} alt="" />
          <span>Heart rate</span>
          <span>116 bpm</span>
        </motion.div>
        {/* hero images  */}
        <img src={hero_image} alt="" className="hero-image" />
        <motion.img
          initial={{ right: "11rem" }}
          whileInView={{ right: "20rem" }}
          transition={transition}
          src={hero_image_back}
          alt=""
          className="hero-image-back"
        />
        <motion.div
          className="calories"
          transition={{ ...transition, type: "tween" }}
          initial={{ right: "37rem" }}
          whileInView={{ right: "28rem" }}
        >
          <img src={calories} alt="" />
          <div>
            <span>calories burned</span>
            <span>220KCal</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default hero;
